import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getNomineeDetailsUrl } from "../utils/urlHelper";

const nomineeDetailsApi = createApi({
  reducerPath: "nomineeDetails",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_AUTH_URL}`,
    prepareHeaders: async (headers) => {
      const token = await sessionStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json; version=3.0");
      headers.set("Source", "LPLWEB");
      return headers;
    },
  }),
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    nomineeDetails: builder.mutation({
      query: (body) => ({
        url: getNomineeDetailsUrl(),
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useNomineeDetailsMutation } = nomineeDetailsApi;

export { nomineeDetailsApi };
